import React from 'react';
import SuccessAlert from '../../components/widgets/SuccessAlert';
import UsersTable from '../../components/Users/UsersTable';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const Users = props => {

  const { t } = useTranslation();
  const location = useLocation();
  return (
    <>

      <div className="content p-4">

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">{t('dashboard:hdgHeading')}</Link></li>
            <li className="breadcrumb-item active" aria-current="page">{t('users:hdgHeading')}</li>
          </ol>
        </nav>

        <SuccessAlert message={location?.state?.message} />

        <UsersTable />

      </div>
    </>
  );
}


export default Users;